<template>
  <div class="swiper-h5">
    <van-swipe
      class="my-swipe"
      :autoplay="5000"
      :lazy-render="true"
      :show-indicators="false"
      indicator-color="white"
    >
      <van-swipe-item v-for="(item, index) in bannerLists" :key="index"
        ><div class="my-swipe-li">
          <img :src="item.mobile_image" alt="" />
          <!-- <img src="@/assets/images/h5/bilibg.png" alt="" /> -->
          <div>
            <a
              class="my-swipe-li-a"
              :href="item.mobile_url"
              target="_blank"
              :ga-data="'10200' + ++index"
            >
              <span>{{$t("h5page.home.text1")}}</span>
              <p><img src="@/assets/images/h5/icon1.png" alt="" /></p>
            </a>
          </div></div
      ></van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  props: ["bannerLists"],
  mounted() {
    // console.log(this.bannerLists);
  },
};
</script>

<style lang="scss" scoped>
.swiper-h5 {
  width: 100%;
  margin-top: 0.48rem;
  .my-swipe {
    width: 100%;
    height: auto;
    .my-swipe-li {
      width: 100%;
      height: auto;
      position: relative;
      > img {
        width: 100%;
      }
      div {
        position: absolute;
        bottom: 25%;
        left: 50%;
        width: 1.53rem;
        height: 0.33rem;
        transform: translateX(-50%);
        background: #50bbe5;
        border-radius: 0.16rem;
        .my-swipe-li-a {
          width: 1.53rem;
          height: 0.33rem;
          display: flex;
          align-items: center;
          justify-content: center;
          span {
            font-size: 0.15rem;
            font-weight: bold;
            color: white;
          }
          p {
            width: 0.15rem;
            height: 0.15rem;
            margin-left: 0.09rem;
            background: #ffffff;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            img {
              width: 0.04rem;
              height: 0.08rem;
            }
          }
        }
      }
    }
  }
}
</style>
